
import React from 'react';
import PropTypes from 'prop-types';
import { DetailPopup } from 'shared/components';
import styled from 'styled-components';
import { 
  Divider,
} from '@mui/material';
import { Text, Title } from 'shared/components';

const ManagerDetails = ({open, onClose}) => {
  return (
    <DetailPopup
      open={open}
      onClose={onClose}
      width="350px"
    >
      <DetailsContainer>
          <Title>Portfolio Manager</Title>
          <Divider/>
          <Br/>
          <Text>Fullname: Jon Doe</Text>
          <Text>Email: jondo@trueimpact.com</Text>
          <Text>Role: Donor</Text>
      </DetailsContainer>
    </DetailPopup>
  );
};

const DetailsContainer = styled.div`
  position: relative;
  flexgrow: 1;
`;

const Br = styled.div`
  width: 100%;
  height: 10px;
`;

ManagerDetails.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default ManagerDetails;